// src/api/webchat.js
const RAW = process.env.REACT_APP_BACKEND_URL || "";
const BASE_URL = RAW.replace(/\/$/, ""); // supprime un éventuel trailing slash

function assertBaseUrl() {
  if (!BASE_URL) throw new Error("REACT_APP_BACKEND_URL manquant");
}

export async function fetchContext(tenantId, url) {
  assertBaseUrl();
  const r = await fetch(`${BASE_URL}/agents/fetch-context`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tenantId, url }),
  });
  if (!r.ok) {
    let code = "";
    try {
      const j = await r.json();
      code = j?.error || "";
    } catch {}
    const err = new Error(`/agents/fetch-context failed (${r.status}) ${code}`);
    err.status = r.status;
    err.code = code;
    throw err;
  }
  return r.json();
}

export async function startConversation(tenantId, agentId, userHints = {}) {
  assertBaseUrl();
  // Pick up optional share token from URL (?k=...)
  let shareToken = "";
  try {
    const urlObj = new URL(window.location.href);
    shareToken = urlObj.searchParams.get("k") || "";
  } catch {}
  const r = await fetch(`${BASE_URL}/webchat/start`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tenantId, agentId, userHints, shareToken }),
  });
  if (!r.ok) {
    let code = "";
    try {
      const j = await r.json();
      code = j?.error || "";
    } catch {}
    const err = new Error(`/webchat/start failed (${r.status}) ${code}`);
    err.status = r.status;
    err.code = code;
    throw err;
  }
  return r.json();
}

export async function sendMessage(payload) {
  assertBaseUrl();
  const r = await fetch(`${BASE_URL}/webchat/message`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    let code = "";
    try {
      const j = await r.json();
      code = j?.error || "";
    } catch {}
    const err = new Error(`/webchat/message failed (${r.status}) ${code}`);
    err.status = r.status;
    err.code = code;
    throw err;
  }
  return r.json();
}

// Optional: fetch public conversation history if backend supports it
export async function getHistory(tenantId, agentId, conversationId) {
  assertBaseUrl();
  const params = new URLSearchParams({ tenantId, agentId, conversationId });
  const r = await fetch(`${BASE_URL}/webchat/history?${params.toString()}`);
  if (!r.ok) throw new Error(`/webchat/history failed (${r.status})`);
  return r.json();
}

export async function manualToggle({ tenantId, agentId, conversationId, active, operatorId }) {
  assertBaseUrl();
  const r = await fetch(`${BASE_URL}/webchat/manualToggle`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tenantId, agentId, conversationId, active, operatorId }),
  });
  if (!r.ok) {
    let code = "";
    try {
      const j = await r.json();
      code = j?.error || "";
    } catch {}
    const err = new Error(`/webchat/manualToggle failed (${r.status}) ${code}`);
    err.status = r.status;
    err.code = code;
    throw err;
  }
  return r.json();
}

export async function manualReply({ tenantId, agentId, conversationId, messageBody }) {
  assertBaseUrl();
  const r = await fetch(`${BASE_URL}/webchat/manualReply`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tenantId, agentId, conversationId, messageBody }),
  });
  if (!r.ok) {
    let code = "";
    try {
      const j = await r.json();
      code = j?.error || "";
    } catch {}
    const err = new Error(`/webchat/manualReply failed (${r.status}) ${code}`);
    err.status = r.status;
    err.code = code;
    throw err;
  }
  return r.json();
}
